export default __webpack_public_path__ + "static/media/drecti.7dc2966b.png";